import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log pour diagnostic (visible dans la console navigateur)
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Render crash:", error, info?.componentStack);
    this.setState({ info });
  }

  handleReload = () => {
    // Recharge en contournant le cache HTTP du navigateur
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = this.state.error?.message || String(this.state.error || "Erreur inconnue");
    const stack = (this.state.info?.componentStack || this.state.error?.stack || "").split("\n").slice(0, 8).join("\n");
    return (
      <div data-testid="app-error-boundary" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0f172a", padding: 24, fontFamily: "Arial, Helvetica, sans-serif" }}>
        <div style={{ maxWidth: 560, width: "100%", background: "#fff", borderRadius: 12, padding: 32, boxShadow: "0 10px 40px rgba(0,0,0,0.35)" }}>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: "#0f172a", margin: "0 0 8px" }}>Une erreur est survenue</h1>
          <p style={{ fontSize: 14, color: "#475569", margin: "0 0 16px", lineHeight: 1.5 }}>
            L'application a rencontré un problème d'affichage. Cliquez sur « Recharger » ci-dessous. Si le problème persiste, faites un rafraîchissement forcé (Ctrl+Maj+R sur Windows, Cmd+Maj+R sur Mac).
          </p>
          <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
            <button data-testid="error-reload-btn" onClick={this.handleReload} style={{ padding: "10px 20px", borderRadius: 8, border: "none", background: "#0f172a", color: "#fff", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>
              Recharger la page
            </button>
            <button data-testid="error-home-btn" onClick={this.handleHome} style={{ padding: "10px 20px", borderRadius: 8, border: "1px solid #cbd5e1", background: "#fff", color: "#0f172a", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>
              Tableau de bord
            </button>
          </div>
          <details style={{ fontSize: 12, color: "#64748b" }}>
            <summary style={{ cursor: "pointer", fontWeight: 600 }}>Détails techniques (à communiquer au support)</summary>
            <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", background: "#f1f5f9", padding: 12, borderRadius: 8, marginTop: 8, maxHeight: 220, overflow: "auto" }}>{msg}
{stack}</pre>
          </details>
        </div>
      </div>
    );
  }
}
